import React, { useEffect, useRef, useState } from 'react'
import Maps from '../Maps/Maps'
import apis from '../../api'
import { Toast } from 'primereact/toast'
import { FilterMatchMode, FilterOperator, addLocale } from 'primereact/api';
import SkeletonTable from '../SkeletonTable/SkeletonTable'
import useWindowDimensions from '../hooks/useDimensions'
import Maps2 from '../Maps/Maps2'
import { Calendar } from 'primereact/calendar';
import { Toolbar } from 'primereact/toolbar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import dateFormat from '../../services/DateFormat.service';
import { Checkbox } from 'primereact/checkbox';
import { Badge } from 'primereact/badge';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './TrackingReport.css'

const TrackingReport = () => {

    const [markers, setMarkers] = useState({
        latitud: [],
        longitud: [],
        descripcion: [],
        icon: [],
        info: []
    })
    const [selectedMarkers, setSelectedMarkers] = useState({
        latitud: [],
        longitud: [],
        descripcion: [],
        icon: [],
        info: []
    })
    const toast = useRef(null);
    const [loadPage, setLoadPage] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [fechaInicio, setFechaInicio] = useState(new Date(Date.now()))
    const [fechaInicioCalendario, setFechaInicioCalendario] = useState(new Date(Date.now()))
    const [novedadesCalendario, setNovedadesCalendario] = useState([])
    const [type, setType] = useState(["IN", "OUT", "ACT"])
    const [inChecked, setInChecked] = useState(true)
    const [outChecked, setOutChecked] = useState(true)
    const [trackChecked, setTrackChecked] = useState(true)

    const { width } = useWindowDimensions()

    const elementWidth = { width: "12rem" }
    const labelStyle = {
        marginTop: "5px",
        paddingTop: "5px"
    }

    const headers = {
        authorization: localStorage.getItem('token')
    }

    let sixDate = new Date(Date.now())
    sixDate.setMonth(sixDate.getMonth() - 12)

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    const [rowData, setRowData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [registros, setRegistros] = useState([]);

    useEffect(() => {
        const fecha = new Date(Date.now())
        setFechaInicio(fecha)
        getMarkers(fecha)
    }, [window.location.pathname])

    useEffect(() => {
        if (window.location.pathname === '/TrackingReport') {
            const fecha = new Date(Date.now())
            setFechaInicio(fecha)
            tableNov(fecha)
        }
    }, [window.location.pathname])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'DAY_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const onChangeTable = (e) => {
        setSelectedRows(e.value)
        let rows = e.value
        if (rows.length > 0) {
            let markers_ = markers
            let lat_ = []
            let lon_ = []
            let desc_ = []
            let icon_ = []
            let info_ = []
            rows.forEach(row => {
                let index = markers_.info.findIndex(e => e.REQUESTS_ID === row.REQUESTS_ID)
                markers.info.forEach((mark, index) => {
                    if (row.REQUESTS_ID === mark.REQUESTS_ID) {
                        desc_.push(markers_.descripcion[index])
                        lat_.push(markers_.latitud[index])
                        lon_.push(markers_.longitud[index])
                        icon_.push(markers_.icon[index])
                        info_.push(mark)
                    }
                })
            })
            console.log(info_)
            setSelectedMarkers({
                ...selectedMarkers,
                latitud: lat_,
                longitud: lon_,
                descripcion: desc_,
                icon: icon_,
                info: info_
            })
        }
        else {
            setSelectedMarkers({
                ...selectedMarkers,
                latitud: [],
                longitud: [],
                descripcion: [],
                icon: [],
                info: []
            })
        }
    }

    const tableNov = (fecha) => {
        setLoadPage(false)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _fechaInicio = fecha ? dateFormat(fecha) : ""
        const _token = localStorage.getItem('token')

        const payload = {
            ENTITY: _entity,
            CLIENT: _client,
            START_DATE: _fechaInicio,
            TOKEN: _token
        }

        try {
            apis.getTrackingEmployees(payload, headers).then(res => {
                let contracts = res.data.CONTRACTS
                console.log(contracts)
                let _contracts = []
                contracts.forEach(cont => {
                    let _contract = {
                        ...cont,
                        FULL_CONTRACT: cont.CONTRACT_ID + '  ' + cont.NAME
                    }
                    _contracts.push(_contract)
                })
                setRows(_contracts)
                setNovedadesCalendario([])
                setRegistros(_contracts)
                setLoading1(false)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
            setLoading1(false)
        }
    }

    const getMarkers = async (fecha, _type = type) => {
        setLoadPage(false)
        setTableData([])
        setSelectedRows([])
        let payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            START_DATE: fecha ? dateFormat(fecha) : "",
            TYPE: _type,
            TOKEN: localStorage.getItem('token')
        }
        if (window.location.pathname === '/MyTrackingReport') {
            payload = {
                ...payload,
                CONTRACT: localStorage.getItem('contract_id')
            }
        }
        let lat = []
        let long = []
        let icon = []
        let desc = []
        let info = []
        try {
            await apis.getTrackingNovelties(payload, headers).then(async res => {
                let tracking = res.data.NOVELTIES_TRK.length > 0 ? res.data.NOVELTIES_TRK : []
                let activities = res.data.NOVELTIES_ACT.length > 0 ? res.data.NOVELTIES_ACT : []
                let tableActivities = []
                let tableTracking = []
                let contractCounter = 0
                console.log(tracking)
                tracking.forEach(trk => {
                    lat.push(parseFloat(trk.GEOLOCATION.LAT))
                    long.push(parseFloat(trk.GEOLOCATION.LON))
                    icon.push({
                        ICON: trk.IMAGES ? trk.IMAGES : [],
                        DETAIL: trk.FILES ? trk.FILES : []
                    })
                    if (!desc.includes(trk.CONTRACT_ID)) {
                        contractCounter += 1
                    }
                    desc.push(trk.CONTRACT_ID)
                    let _info = {
                        DATE: trk.DATE,
                        TIME: trk.TIME,
                        TYPE: trk.TYPE && trk.TYPE,
                        STATUS: trk.STATUS && trk.STATUS.split('|')[1],
                        NUMBER_ID: trk.NUMBER_ID,
                        TITLE: trk.TYPE === 'IN' ? 'Entrada' : 'Salida',
                        REQUESTS_ID: trk.REQUESTS_ID,
                        CONTRACT_ID: trk.CONTRACT_ID
                    }
                    info.push(_info)
                    tableTracking.push(_info)
                })
                activities.forEach(trk => {
                    lat.push(parseFloat(trk.GEOLOCATION.LAT))
                    long.push(parseFloat(trk.GEOLOCATION.LON))
                    icon.push({
                        ICON: trk.IMAGES ? trk.IMAGES : [],
                        DETAIL: trk.FILES ? trk.FILES : []
                    })
                    if (!desc.includes(trk.CONTRACT_ID)) {
                        contractCounter += 1
                    }
                    desc.push(trk.CONTRACT_ID)
                    let _info = {
                        DATE: trk.DATE,
                        TIME: trk.TIME,
                        TYPE: trk.TYPE ? trk.TYPE : 'ACT',
                        STATUS: trk.STATUS && trk.STATUS.split('|')[1],
                        NUMBER_ID: trk.NUMBER_ID,
                        TITLE: trk.ACTIVITY_NAME,
                        REQUESTS_ID: trk.REQUESTS_ID,
                        CONTRACT_ID: trk.CONTRACT_ID
                    }
                    info.push(_info)
                    tableActivities.push(_info)
                })
                let tableData = [...tableTracking, ...tableActivities]
                tableData = tableData.sort((a, b) => parseInt(b.REQUESTS_ID) - parseInt(a.REQUESTS_ID))
                setRowData(tableData)
                if (contractCounter === 1) {
                    setTableData(tableData)
                    setSelectedRows(tableData)
                }
                setMarkers({
                    ...markers,
                    latitud: lat,
                    longitud: long,
                    descripcion: desc,
                    icon: icon,
                    info: info
                })
                setSelectedMarkers({
                    ...selectedMarkers,
                    latitud: lat,
                    longitud: long,
                    descripcion: desc,
                    icon: icon,
                    info: info
                })
                setLoadPage(true)
            })
        }
        catch (err) {
            setLoadPage(true)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const onSelect = (rows) => {
        setRegistros(rows)
        console.log(rows)
        console.log(rowData)
        if (rows.length > 0) {
            console.log(markers)
            let markers_ = markers
            let lat_ = []
            let lon_ = []
            let desc_ = []
            let icon_ = []
            let info_ = []
            rows.forEach(row => {
                let index = markers_.descripcion.findIndex(e => e.split('|')[0] === row.CONTRACT_ID)
                markers.descripcion.forEach((mark, index) => {
                    let contract = mark.split('|')[0]
                    if (row.CONTRACT_ID === contract) {
                        desc_.push(mark)
                        lat_.push(markers_.latitud[index])
                        lon_.push(markers_.longitud[index])
                        icon_.push(markers_.icon[index])
                        info_.push(markers_.info[index])
                    }
                })
            })
            console.log(info_)
            setSelectedMarkers({
                ...selectedMarkers,
                latitud: lat_,
                longitud: lon_,
                descripcion: desc_,
                icon: icon_,
                info: info_
            })
            if (rows.length === 1) {
                let filterTable = rowData.filter(t => rows[0].CONTRACT_ID === t.CONTRACT_ID.split("|")[0])
                setTableData(filterTable)
                setSelectedRows(filterTable)
            }
            else {
                setTableData([])
                setSelectedRows([])
            }
        }
        else {
            setSelectedMarkers({
                ...selectedMarkers,
                latitud: [],
                longitud: [],
                descripcion: [],
                icon: [],
                info: []
            })
            setTableData([])
            setSelectedRows([])
        }
    }

    const handleCheckboxChange = (checked, value) => {
        console.log(value, checked)
        if (value === 'IN') {
            if (checked) {
                if (outChecked && trackChecked) {
                    setType(["IN", "OUT", "ACT"]);
                    getMarkers(fechaInicio, ["IN", "OUT", "ACT"]);
                }
                else if (trackChecked && !outChecked) {
                    setType(["IN", "NULL", "ACT"]);
                    getMarkers(fechaInicio, ["IN", "NULL", "ACT"]);
                }
                else if (outChecked && !trackChecked) {
                    setType(["IN", "OUT", "NULL"]);
                    getMarkers(fechaInicio, ["IN", "OUT", "NULL"]);
                }
                else if (!outChecked && !trackChecked) {
                    setType(["IN", "NULL", "NULL"]);
                    getMarkers(fechaInicio, ["IN", "NULL", "NULL"]);
                }
            }
            else {
                if (trackChecked && outChecked) {
                    setType(["NULL", "OUT", "ACT"]);
                    getMarkers(fechaInicio, ["NULL", "OUT", "ACT"]);
                }
                else if (trackChecked && !outChecked) {
                    setType(["NULL", "NULL", "ACT"])
                    getMarkers(fechaInicio, ["NULL", "NULL", "ACT"]);
                }
                else if (outChecked && !trackChecked) {
                    setType(["NULL", "OUT", "NULL"]);
                    getMarkers(fechaInicio, ["NULL", "OUT", "NULL"]);
                }
                else if (!outChecked && !trackChecked) {
                    setType(["NULL", "NULL", "NULL"]);
                    getMarkers(fechaInicio, ["NULL", "NULL", "NULL"]);
                }
            }
        }
        else if (value === 'OUT') {
            if (checked) {
                if (inChecked && trackChecked) {
                    setType(["IN", "OUT", "ACT"]);
                    getMarkers(fechaInicio, ["IN", "OUT", "ACT"]);
                }
                else if (inChecked && !trackChecked) {
                    setType(["IN", "OUT", "NULL"]);
                    getMarkers(fechaInicio, ["IN", "OUT", "NULL"]);
                }
                else if (trackChecked && !inChecked) {
                    setType(["NULL", "OUT", "ACT"]);
                    getMarkers(fechaInicio, ["NULL", "OUT", "ACT"]);
                }
                else if (!trackChecked && !inChecked) {
                    setType(["NULL", "OUT", "NULL"]);
                    getMarkers(fechaInicio, ["NULL", "OUT", "NULL"]);
                }
            }
            else {
                if (trackChecked && inChecked) {
                    setType(["IN", "NULL", "ACT"]);
                    getMarkers(fechaInicio, ["IN", "NULL", "ACT"]);
                }
                else if (inChecked && !trackChecked) {
                    setType(["IN", "NULL", "NULL"]);
                    getMarkers(fechaInicio, ["IN", "NULL", "NULL"]);
                }
                else if (trackChecked && !inChecked) {
                    setType(["NULL", "NULL", "ACT"]);
                    getMarkers(fechaInicio, ["NULL", "NULL", "ACT"]);
                }
                else if (!trackChecked && !inChecked) {
                    setType(["NULL", "NULL", "NULL"]);
                    getMarkers(fechaInicio, ["NULL", "NULL", "NULL"]);
                }
            }
        }
        else if (value === 'ACT') {
            if (checked) {
                if (inChecked && outChecked) {
                    setType(["IN", "OUT", "ACT"]);
                    getMarkers(fechaInicio, ["IN", "OUT", "ACT"]);
                }
                else if (inChecked && !outChecked) {
                    setType(["IN", "NULL", "ACT"]);
                    getMarkers(fechaInicio, ["IN", "NULL", "ACT"]);
                }
                else if (outChecked && !inChecked) {
                    setType(["NULL", "OUT", "ACT"]);
                    getMarkers(fechaInicio, ["NULL", "OUT", "ACT"]);
                }
                else if (!outChecked && !inChecked) {
                    setType(["NULL", "NULL", "ACT"]);
                    getMarkers(fechaInicio, ["NULL", "NULL", "ACT"]);
                }
            }
            else {
                if (inChecked && outChecked) {
                    setType(["IN", "OUT", "NULL"]);
                    getMarkers(fechaInicio, ["IN", "OUT", "NULL"]);
                }
                else if (inChecked && !outChecked) {
                    setType(["IN", "NULL", "NULL"]);
                    getMarkers(fechaInicio, ["IN", "NULL", "NULL"]);
                }
                else if (outChecked && !inChecked) {
                    setType(["NULL", "OUT", "NULL"]);
                    getMarkers(fechaInicio, ["NULL", "OUT", "NULL"]);
                }
                else if (!outChecked && !inChecked) {
                    setType(["NULL", "NULL", "NULL"]);
                    getMarkers(fechaInicio, ["NULL", "NULL", "NULL"]);
                }
            }
        }
        // Actualizar el estado del checkbox correspondiente
        value === 'IN' ? setInChecked(checked) : value === 'OUT' ? setOutChecked(checked) : setTrackChecked(checked);
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap justify-content-center align-content-center">
                <Calendar id="navigators" value={fechaInicio}
                    onChange={(e) => {
                        setFechaInicio(e.value);
                        setFechaInicioCalendario(e.value);
                        if (window.location.pathname === '/TrackingReport') {
                            tableNov(e.value)
                        }
                        console.log(type)
                        getMarkers(e.value)
                    }}
                    maxDate={new Date(Date.now())}
                    locale="es" dateFormat="dd-mm-yy" yearRange="1900:2150" showIcon style={{ ...elementWidth, marginBottom: '1rem' }}
                    placeholder="Fecha novedades"
                />
                &nbsp;
                <div className="flex flex-wrap justify-content-center gap-2">
                    <div className="flex align-items-center">
                        <Badge className="ml-2 mr-1" value="Entrada" size="medium" severity="success" />
                        <Checkbox inputId="IN" value="IN" className='check-in' onChange={(e) => {
                            handleCheckboxChange(e.checked, e.value)
                        }}
                            checked={inChecked} />
                    </div>
                    <div className="flex align-items-center">
                        <Badge className="ml-1 mr-1" value="Salida" size="medium" severity="danger" />
                        <Checkbox inputId="OUT" value="OUT" className='check-out' onChange={(e) => {
                            handleCheckboxChange(e.checked, e.value)
                        }}
                            checked={outChecked} />
                    </div>
                    <div className="flex align-items-center">
                        <Badge className="ml-1 mr-1" value="Actividades" size="medium" severity="info" />
                        <Checkbox inputId="ACT" value="ACT" className='check-act' onChange={(e) => {
                            handleCheckboxChange(e.checked, e.value)
                        }}
                            checked={trackChecked} />
                    </div>
                </div>
            </div>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <MultiSelect value={registros} options={rows} onChange={(e) => onSelect(e.value)} optionLabel="NAME" filter filterBy='FULL_CONTRACT'
                placeholder="Empleados" itemTemplate={itemTemplate} className="w-full md:w-20rem" />
        )
    }

    const itemTemplate = (option) => {
        const foto = option.IMAGES ? option.IMAGES : process.env.REACT_APP_PROFILE_PIC
        return (
            <React.Fragment>
                <img alt={""} src={foto} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                &nbsp;
                &nbsp;
                &nbsp;
                <span>{option.CONTRACT_ID} - {option.NAME}</span>
            </React.Fragment>
        );
    };

    const photoBodyTemplate = (rowData) => {
        const photo = rowData.IMAGES;
        return (
            <React.Fragment>
                <img alt={""} src={photo} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                &nbsp;
                &nbsp;
                &nbsp;
                <span>{rowData.CONTRACT_ID} - {rowData.NAME}</span>
            </React.Fragment>
        );
    }

    return (
        <div className='px-4 py-5 md:px-6 lg:px-8'>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">{window.location.pathname === '/MyTrackingReport' && 'Mi '}Seguimiento</span>
            </div>
            <div className="mt-6" style={{ height: '70vh', backgroundColor: 'transparent' }}>
                <SkeletonTable load={loadPage}>
                    <Toolbar className='card flex flex-row' start={leftToolbarTemplate} end={window.location.pathname === '/TrackingReport' && rightToolbarTemplate} />
                    <div className='thing4'>
                        <div style={{ width: window.location.pathname === '/TrackingReport' && tableData.length > 0 && width > 918 ? '90%' : '100%' }}>
                            <Maps2 latitud={selectedMarkers.latitud} longitud={selectedMarkers.longitud} descripcion={selectedMarkers.descripcion}
                                icon={selectedMarkers.icon} info={selectedMarkers.info} />
                        </div>
                        {window.location.pathname === '/TrackingReport' && tableData.length > 0 &&
                            <DataTable className="text-xs" value={tableData} first={first2} rows={rows2} scrollable scrollDirection='horizontal'
                                selectionMode="multiple" selection={selectedRows} onSelectionChange={(e) => onChangeTable(e)} dataKey="REQUESTS_ID"
                                size="small" style={{ width: width > 918 ? "26rem" : '100%' }}>
                                <Column selectionMode="multiple"></Column>
                                <Column field="TITLE" bodyStyle={{ maxWidth: '8rem', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} header="Actividad"></Column>
                                <Column field="DATE" header="Fecha"></Column>
                                <Column field="TIME" header="Hora"></Column>
                            </DataTable>}
                    </div>
                </SkeletonTable>
            </div>
        </div>
    )
}

export default TrackingReport
